module.exports = {"embedded":"false","defaultView":"Interior"}